import React, { useCallback, useRef, useState } from 'react';
import { Popup } from 'antd-mobile-v5';
import moment from 'moment';
import {
  REWARD_RECEIVED_STATUS,
  REWARD_UNRECEIVE_STATUS,
  REWARD_EXPIRED_STATUS,
  REWARD_BUTTON_TEDXT_MAP,
  EMPTY_DATA_MAP,
} from '../constants';
import styles from '../index.less';
import EmptyData from './EmptyData';
import { reportClick } from '@/utils/report';

const VipRewardList = ({ visible, onClose, recordData, onReceiveReward, pageName }) => {
  const listRef = useRef(null);
  const [rewardType, setRewardType] = useState('udl');

  const displayRewardList = recordData[rewardType] || [];

  const handleTabChange = useCallback(
    type => {
      setRewardType(type);
      if (listRef.current) {
        listRef.current.scrollTop = 0;
      }
      reportClick({
        page_name: pageName,
        button_name: `xl_pc_${type}_tab`,
      });
    },
    [pageName]
  );

  const handleClose = useCallback(() => {
    onClose();
    setRewardType('udl');
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
  }, [onClose]);

  const renderXlAccountText = useCallback((status, account) => {
    if (status === REWARD_UNRECEIVE_STATUS) {
      return `领取后自动发放至迅雷账号（${account}）`;
    } else if (status === REWARD_RECEIVED_STATUS) {
      return `已发放至迅雷账号（${account}）`;
    }
    return '';
  }, []);

  const renderTimeText = useCallback((status, st, et) => {
    switch (status) {
      // 未领取，展示
      case REWARD_UNRECEIVE_STATUS:
        const diffDays = moment(et).diff(moment(), 'days');
        console.log('diffDays: ', diffDays);
        return `还剩${diffDays}天失效`;
      case REWARD_RECEIVED_STATUS:
        return `${st}领取`;
      case REWARD_EXPIRED_STATUS:
        return `${st}失效`;
      default:
        return '--';
    }
  }, []);

  return (
    <Popup
      visible={visible}
      onClose={handleClose}
      showCloseButton
      recordData
      bodyStyle={{
        borderTopLeftRadius: '0.4rem',
        borderTopRightRadius: '0.4rem',
      }}
    >
      <div className={`${styles['xl-vip-popup-wrapper']} ${styles['reward']}`}>
        <h4 className={styles['xl-vip-popup-title']}>领取会员</h4>
        <ul className={styles['reward-tabs']}>
          <li
            className={`${styles['reward-tab']} ${rewardType === 'udl' ? styles['active'] : ''}`}
            onClick={() => handleTabChange('udl')}
          >
            待领取
          </li>
          <li
            className={`${styles['reward-tab']} ${rewardType === 'rdl' ? styles['active'] : ''}`}
            onClick={() => handleTabChange('rdl')}
          >
            已领取
          </li>
          <li
            className={`${styles['reward-tab']} ${rewardType === 'edl' ? styles['active'] : ''}`}
            onClick={() => handleTabChange('edl')}
          >
            已失效
          </li>
        </ul>
        {/* <p
          className={`${styles['reward-account']} ${
            displayRewardList?.length > 0 ? '' : styles['hidden']
          }`}
        >
          *领取后将自动发放至迅雷账号（{recordData.xa}）
        </p> */}
        {displayRewardList?.length > 0 ? (
          <ul className={styles['reward-list']} ref={listRef}>
            {displayRewardList?.map((item, index) => {
              const { s, ti, mt, st, et, sn, xa } = item;
              return (
                <li
                  key={`${ti}-${index}`}
                  className={`${styles['reward-item']} ${styles[`status-${s}`]}`}
                >
                  <div className={styles['reward-info']}>
                    <p className={styles['reward-name']}>迅雷超级会员周卡</p>
                    <p className={styles['reward-text']}>发放时间：{mt}</p>
                    <p className={styles['reward-text']}>打卡设备：{sn}</p>
                    <p className={styles['reward-xa']}>{renderXlAccountText(s, xa)}</p>
                  </div>
                  <div className={styles['reward-action']}>
                    <button
                      className={`${styles['reward-button']} ${
                        s !== REWARD_UNRECEIVE_STATUS ? styles['disabled'] : ''
                      }`}
                      // disabled={s !== REWARD_UNRECEIVE_STATUS}
                      onClick={() => onReceiveReward(sn, ti, s)}
                    >
                      {REWARD_BUTTON_TEDXT_MAP[s]}
                    </button>
                    <p className={styles['reward-time']}>{renderTimeText(s, st, et)}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className={styles['reward-list']}>
            <EmptyData text={EMPTY_DATA_MAP[rewardType]} />
          </div>
        )}
      </div>
    </Popup>
  );
};
export default VipRewardList;
